import { isUrl } from 'support'
import isBlank from 'is-blank'
import last from 'just-last'
import fecha from 'fecha'
import { embedlyApi } from 'api'
import { foldazApi } from 'api'
import createFormModule from '../../utils/createFormModule'
import {
  INVITATION_FORM_REQUEST,
  INVITATION_FORM_SUCCESS,
  INVITATION_FORM_ERROR,
  SET_EMAIL_ADDRESSES,
  SET_ROLE
} from './types'

const formModule = createFormModule({
  resourcesPath: '/invitations',
  resourcesName: 'invitation',
  resourcePath: '/invitations/:invitationId',
  resourceName: 'invitation'
})

const REQUIRED_FIELDS = ['emailAddresses', 'role']

export const state = {
  ...formModule.state,
  request: {
    isLoading: false,
    error: null
  },
  form: {
    id: null,
    emailAddresses: '',
    role: false
  }
}

export const mutations = {
  ...formModule.mutations,
  [INVITATION_FORM_REQUEST] (state) {
    state.request.isLoading = true
  },
  [INVITATION_FORM_SUCCESS] (state) {
    state.request.isLoading = false
    state.request.error = null
  },
  [INVITATION_FORM_ERROR] (state, error) {
    state.request.isLoading = false
    state.request.error = error
  },
  [SET_EMAIL_ADDRESSES] (state, value) {
    state.form.emailAddresses = value
  },
  [SET_ROLE] (state, value) {
    state.form.role = value ? 'admin' : 'editor'
  }
}

export const actions = {
  ...formModule.actions,
  setEmailAddresses ({ commit }, value) {
    commit(SET_EMAIL_ADDRESSES, value)
  },
  setRole ({ commit }, value) {
    commit(SET_ROLE, value)
  },
  customSubmit ({ commit, dispatch, state }) {
    commit(INVITATION_FORM_REQUEST)
    const invitationId = state.form.id
    const promise = isBlank(invitationId)
      ? dispatch('create')
      : dispatch('update', { invitationId })

    return promise
      // .then(({ data }) => commit('SET_INVITATION', data.content, { root: true }))
  },
  reset ({ dispatch }) {
    dispatch('setId', null)
    dispatch('setEmailAddresses', '')
    dispatch('setRole', false)
  }
}

export const getters = {
  ...formModule.getters,
  isSaveable ({ form }) {
    const blankFields = REQUIRED_FIELDS.filter(field => isBlank(form[field]))
    return blankFields.length <= 0
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/invitations/invitationForm.js